export default __webpack_public_path__ + "static/marcrmcase1-23550175590ec7f0ff3a7fc3c25a6d72.png";